export default __webpack_public_path__ + "static/media/customers.bb4b4668.png";